import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-packetfile',
  templateUrl: './packetfile.component.html',
  styleUrl: './packetfile.component.css'
})
export class PacketfileComponent implements ICellRendererAngularComp  {
  constructor(private readonly ngxSpinner: NgxSpinnerService) {}

  refresh(){
    return false;
  }
  params;

  agInit(params): void {
    this.params = params;
  }

  downloadpacket($event) {
    this.ngxSpinner.show();
    if (this.params.downloadpacket instanceof Function) {
      const params = { //NOSONAR
        event: $event,
        rowData: this.params.node.data,
        api:this.params.gridApi
      }
      this.params.downloadpacket(this.params);

    }
    setTimeout(()=> {
      this.ngxSpinner.hide();
    },2000)
  }
}
